import React, { Component } from 'react';

// Components Imports
import NormalField from './NormalField';

class ProjectBasicInfo extends Component {
    render() {
        const projectCreateDate = new Date(Date.parse(this.props.project.insertedAt)).toLocaleTimeString() + " - " +new Date(Date.parse(this.props.project.insertedAt)).toLocaleDateString();
        const creator = this.props.project.creator ?  this.props.project.creator.fullName : "No data";
        return (
            <div>
                <div>
                    <NormalField
                        label="Project Number"
                        input={this.props.project.number} />
                    <NormalField
                        label="Status"
                        input={this.props.project.status} />
                </div>
                <div>
                    <NormalField
                        label="Start Date"
                        input={new Date(Date.parse(this.props.project.startDate)).toDateString()} />
                    <NormalField
                        label="End Date"
                        input={new Date(Date.parse(this.props.project.endDate)).toDateString()} />
                </div>
                <div>
                    <NormalField
                        label="Site Name"
                        input={this.props.project.siteName} />
                    <NormalField
                        label="Site Address"
                        input={this.props.project.siteAddress} />
                </div>
                <div>
                    <NormalField
                        label="Location"
                        input={this.props.project.location} />
                    <NormalField
                        label="Region"
                        input={this.props.project.region.name} />
                </div>
                <div>
                    <NormalField
                        label="Created by"
                        input={creator} />
                    <NormalField
                        label="Creation date"
                        input={projectCreateDate} />
                </div>
            </div>
        );
    }
}

export default ProjectBasicInfo;


// WEBPACK FOOTER //
// src/components/innerComponents/ProjectBasicInfo.js